import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Menu, Transition } from '@headlessui/react';
import { Fragment, PropsWithChildren } from 'react';

import { Props } from './types';

/**
 * @deprecated Do not use this component. There is no equivalent yet at the root
 * of the UI folder — a new version should be built there using the current
 * design-system patterns (tailwind-variants + Headless UI, see src/ui/Button)
 * instead of using this legacy component.
 */
const Dropdown = ({
  buttonAriaLabel,
  buttonText,
  children,
  customButtonClassName,
  customWrapperClassName,
  customMenuClassName,
  items,
  showChevronIcon = true
}: PropsWithChildren<Props>) => {
  const dropdownClasses =
    'inline-flex items-center w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 dark:ring-gray-700 hover:bg-gray-50';
  return (
    <>
      <Menu
        as="div"
        className={
          customWrapperClassName ? customWrapperClassName : 'relative inline-block text-left'
        }>
        <div className="flex items-center justify-center">
          <Menu.Button
            aria-label={
              buttonAriaLabel ?? (typeof buttonText === 'string' ? buttonText : 'Open dropdown')
            }
            className={`text-left ${customButtonClassName ? customButtonClassName : dropdownClasses}`}>
            {buttonText}

            {showChevronIcon && (
              <FontAwesomeIcon
                aria-hidden={true}
                className="h-3.5 w-3.5 text-gray-500"
                icon={faChevronDown}
              />
            )}
          </Menu.Button>
        </div>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95">
          <Menu.Items
            className={`absolute z-30 w-max rounded-md bg-white shadow-lg ring-1 ring-gray-400 dark:ring-gray-700 ring-opacity-5 focus:outline-hidden ${
              customMenuClassName ?? 'right-0 mt-1 origin-top-right'
            }`}>
            <div className="py-1">
              {children}

              {items?.map((item) => (
                <Menu.Item key={item.key}>
                  <div className="dropdown-item block text-sm w-full hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 cursor-pointer">
                    {item}
                  </div>
                </Menu.Item>
              ))}
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </>
  );
};

export default Dropdown;
